/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {configureDirectDebitPreferences} from '../api'

export const useMutationConfigureDirectDebitPreferences = createReactQueryMutationHook('configureDirectDebitPreferences', configureDirectDebitPreferences)
